/*
 * @Author: weijinpeng
 * @LastEditors: ningrui
 * @Date: 2025-08-07 10:13:42
 * @LastEditTime: 2025-10-31 15:30:55
 * @Description: 
 */
export default {
    PoweredbyMVGX: 'MVGX 提供支持',
    Itlooks: '您似乎正在使用与保存数据时不同的浏览器。请切换回之前的浏览器，重新扫描二维码，或向展位的工作人员寻求帮助。',
    Close: '关闭',
    TotalCarbonFootprint: '您旅程的碳足迹总和',
    To: '至',
    Stat: '开始',
    End: '结束',
    date: '选择日期',
    totalemission:'总排放量:',
    Trips: '行程',
    Stays: '住宿',
    Thankyoufor: '感谢您参与我们的"为可持续发展拍照"活动。',
    Yourinputhelps: '您的参与有助于 MVGX 追踪并减少世界游泳锦标赛的碳足迹，使其更加环保并更具影响力。',
    Yourinputhelps1: '感谢您参加“第八届中国国际进口博览会”。基于我们共同的绿色愿景，MVGX将助力中国国际进口博览会量化并降低本次活动碳足迹，让活动更绿色低碳，同时为地球带来积极的改变。',
    Together: '让我们共同为社区和地球带来有意义的改变。',
    CarbonFootprintNeutralized: '碳足迹已中和',
    ThankYouforNeutralizing: '感谢您中和了您的碳足迹！',
    NAME: '姓名',
    EVENTNAME: '活动名称',
    CARBONNEUTRALISATION: '碳中和交易 ID',
    CARBONFOOTPRINT: '申报碳足迹',
    DATEOFCARBON: '碳中和代币燃烧日期',
    Your: '您的',
    tripcarbon: '旅行碳足迹正在以太坊区块链上进行中和。',
    DownloadCertificate: '下载证书',
    CARBONNEUTRALITYCERTIFICATE: '碳中和证书',
    Thisistocertifythat: '兹证明',
    hasneutralized: '已中和',
    oftheirCarbonFootprint: '的碳足迹',
    forthe:'用于',
    CERTIFICATENO: '证书编号',
    CARBONNEUTRALITYEVENT: '碳中和活动',
    CARBONFOOTPRINTDECLARED: '申报碳足迹',
    CARBONCREDITSRETIRED: '已注销碳信用',
    CarbonNeutralityTokensburnt: '已燃烧的碳中和代币',
    DATEOFCARBONNEUTRALITYTOKENSBURNT: '碳中和代币燃烧日期',
    CERTIFICATIONTEXT: '认证文本',
    hasneutralised: '已中和',
    oftheirCarbonFootprintforthe: '的碳足迹，用于',
    equivalent:'当量',
    EQUIVALENT: '当量',
    event: '活动。',
    CARBONNEUTRALISATIONTRANSACTIONID: '碳中和交易 ID',
    MetaVerseGreenExchange: 'MVGX科技集团',
    NetZeroDiary: '净零日记',
    From:'从',
    To: '至',
    CarbonFootprint: '碳足迹',
    CityTrains: '火车',
    Car_Taxi: '汽车/出租车',
    e_Bike: '电动自行车',
    Motorcycle: '摩托车',
    Tram: '电车',
    Bus: '公交车',
    Airplane: '飞机',
    SeaFerry: '轮船',
    Stays: '住宿',
    City: '城市',
    Night: '晚',
    bed: '1 床',
    beds: '2 床',
    Addaccommodationbeds: '增加住宿床位',
    CalculateMyCarbonFootprint: '计算我的碳足迹',
    OK: '确定',
    ChooseTransport: '选择交通工具',
    IndividualorGroupAccomodation: '个人或团体住宿',
    Pleasenotethatonceconfirmedthe: '请注意，一旦确认，',
    informationsavedcannolongerbemodified: '保存的信息将无法再修改',
    Cancel: '取消',
    Confirm: '确认',
    Pleaseselectadate: '请选择日期',
    Departure: '出发',
    Leavingfrom: '出发地',
    Destination: '目的地',
    Goingto: '前往',
    CarbonNeutralFor: '碳中和对象',
    Description: '描述',
    IssuedBy: '签发方',
    TokenStandard: '代币标准',
    Blockchain: '区块链',
    Youwillhavetheoption: '付款后，您可以选择在 NFT 上添加个性化留言',
    PurchaseNow: '立即购买',
    Sorrythecodelinked: '抱歉，与此卡关联的代码未获授权',
    Email: '电子邮件',
    Pleasevisit: '有关我们产品和服务的更多信息，请访问',
    formoreinformationabout: '',
    Iagreetosharemypersonaldata: '我同意共享我的个人数据',
    Pleaseenteryournametocontinue: "请输入您的姓名以继续。",
    Pleaseenteryouremailaddress: '请输入您的电子邮件地址以继续。',
    Pleaseenterthecorrectemailaddress: '请输入正确的电子邮件地址',
    Pleaseselectthecheckboxtocontinue: '请勾选同意以继续',
    YourCarbonNeutralisationisinProcess: "我们正在为您提交碳足迹数据，请稍等...",
    OrderDetails: '订单详情',
    NFTName: 'NFT 名称',
    CarbonNeutralFor: "碳中和对象",
    NFTAmount: "NFT 数量",
    NameorNickname: "姓名或昵称（必填）",
    Addyournameornickname: "在此输入您的姓名或昵称，将显示在 NFT 上。",
    PersonalizedMessage: "个性化留言",
    Typeinyourpersonalisedtextsdisplaye: "在此输入您的个性化留言，将显示在 NFT 上（可选）。",
    Iwouldliketodisplay:"我希望在 MVGX 的网络画廊中展示所购买的 NFT，并同意根据 MVGX 的隐私政策接受条款与条件。",
    Preview: "预览",
    GenerateYourNFT: "生成您的 NFT",
    InvalidOrderID: "订单 ID 无效，将为您跳转至付款页面。",
    Nameisrequired: "生成 NFT 需要填写姓名",
    FailedtogenerateyourNFT: "生成 NFT 失败。很抱歉给您带来不便，请稍后再试。",
    Maximum64Characters: "最多 64 个字符",
    Pleasesetapasscodeforfutureaccess: "请创建您的密码",
    Passcodeis6digits: "6 位数字密码",
    Submit: "提交",
    Pleasescreenshot: "请截图并保存以下二维码",
    ThisQRcode: "此二维码是您今后访问的唯一入口，请妥善保管。",
    Pleaseseta6digitspasscode: "请设置一个 6 位数字密码",
    ThisCardHasAlreadyBeenUsed: '此卡已被用于碳中和',
    ThisCardHasBeenSuspended: "此卡已被暂停使用！",
    ThisCardHasAlreadyExpired: "此卡已过期！",
    Theaddresshasexpiredandcannotbeaccessed: "该地址已过期，无法访问",
    ThisCardHasAlready: "此卡已被用于碳中和",
    VisitMVGX: "访问 MVGX",
    Pleasesubmiyourquery: '请通过以下表格提交您的问题。',
    SerialNo: "序列号",
    EventName: "活动名称",
    FullName: "全名",
    ContactNumber: "联系电话",
    Ifrequirereply: "如需回复",
    abriefdescription: "请简要描述您的需求或遇到的问题。",
    Send: "发送",
    Wewillreplywithi: "我们将在 1 个工作日内回复您",
    Pleasebeinformedour: "请注意，我们的工作时间为每周一至周五上午 9 点至下午 6 点（公众假期除外）",
    SubmitSuccessful: '提交成功！',
    Pleaseenterthecorrectemailaddress: '请输入正确的电子邮件地址',
    Pleaseenterthequestion: "请输入您要反馈的问题。",
    Congratulations: "恭喜！您的 NFT 订单已成功处理！",
    TheNFTdisplayed: "上方显示的 NFT 仅为示意图，实际文本布局可能有所不同。",
    OCBCPublicSectorDay: "华侨银行公共部门日",
    TransactionHash: "交易哈希",
    TokenID: "代币 ID",
    Moredetailshavebeensent: "更多详情已发送至您的电子邮件地址",
    Welcome: "欢迎",
    Yourecalculating: "您正在计算您的个人碳足迹！",
    SerialNo: "序列号",
    EnterPassword: "输入密码",

    Makepledge: "做出可持续发展承诺",
    Makepledge1: "请选择承诺以继续",
    Pleaseteamname: "请选择队伍",
    Pleaseteamname1: "请选择队伍以继续",

    Notice: "提示",

    ple0: "自带水杯,减少一次性用品消耗",
    ple01: "低碳赛事,无痕营地",
    ple1:"写我自己的誓言",
    ple2:"我每天都会带一个可重复使用的瓶子",
    ple3:"我一周不吃肉",
    ple4:"我将乘坐公共交通工具而不是开车",
    ple5:"我会拒绝一次性塑料袋",
    ple6:"我会关掉不用的灯和电器",
    ple7:"我会在家里和工作中妥善回收",
    ple8:"我会减少飞行次数，选择虚拟会议",
    ple9:"我会买当地和时令的食物",
    ple10:"我会减少淋浴时间以节约用水",
    ple11:"我会把厨房垃圾堆肥",
    ple12:"我会穿更多二手或可持续的衣服",
    ple13:"我会带一个可重复使用的购物袋",
    ple14:"不使用时,我会拔下充电器",
    ple15:"今年我要种树",
    ple16:"我将以真正的气候行动支持品牌",

    Pledgetxt: '为低碳世界践行承诺',
    Footprintbtn: '提交我的碳足迹',
    checktxt: '在提交此表格时,您同意MVGX收集、使用和披露您的个人数据（包括但不限于您的电话号码、肖像、图像和/或视频）,用于参与中国国际进口博览会的"可持续快拍"粉丝活动、可持续发展相关报告以及访问我们的服务。您的个人数据将严格按照我们的隐私政策进行收集、使用和披露。'
}
